import { useState, useCallback } from 'react';
import { Form } from 'antd';

const useForm = ({ initialMode = FormMode.reset, onSubmit } = {}) => {
  const [form] = Form.useForm();
  const [mode, setMode] = useState(initialMode);
  const [extraValues, setExtraValues] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const create = useCallback(() => {
    setMode(FormMode.create);
  }, []);

  const edit = useCallback((values) => {
    form.setFieldsValue(values);
    setMode(FormMode.edit);
  }, [form]);

  const reset = useCallback(() => {
    form.resetFields();
    setExtraValues({});
    setMode(FormMode.reset);
  }, [form]);

  const onSubmitHandler = useCallback((values, ...rest) => {
    if (typeof onSubmit === 'function' && !isSubmitting) {
      const allValues = {
        ...extraValues,
        ...values,
      };
      setIsSubmitting(true);
      Promise.resolve(
        onSubmit(allValues, { ...form, mode, isSubmitting: true })
      ).finally(() => {
        setIsSubmitting(false);
      });
    }
  }, [extraValues, onSubmit, isSubmitting, form, mode]);

  return [{
    ...form,
    mode,
    isSubmitting,
    extraValues,
    create,
    edit,
    reset,
    onSubmit: onSubmitHandler,
    setExtraValues,
  }];
};

export const FormMode = {
  create: 'create',
  edit: 'edit',
  reset: 'reset',
};

export default useForm;
